import React, { useEffect, useState } from "react";
import Layout from "../../components/yenimahalle/Layout";
import BasicHeader from "../../components/yenimahalle/BasicHeader";
import ListGrid from "components/yenimahalle/ListGrid";
import PortalApi from "api/PortalApi";
import { Tender } from "models/Response/Portal";
import { useNavigate } from "react-router-dom";

interface TenderItems {
  id: number;
  title: string;
  description?: string;
}

const IhaleDuyurulari: React.FC = () => {
  const navigate = useNavigate();
  const [tenderItems, setTenderItems] = useState<TenderItems[]>([]);

  const handleTenderClick = (item: Tender & { id: number }) => {
    const url = `/IhaleDetay/${item.id}`;
    navigate(url);
  };

  useEffect(() => {
    const fetchData = async () => {
      const response = await PortalApi.getActiveTenders();
      if (response && response.tenderListe) {
        const mappedItems = response.tenderListe.map((item: Tender) => ({
          id: item.id,
          title: item.tenderHeader,
          description: `${item.tenderIntroText}`,
        }));
        setTenderItems(mappedItems);
      }
    };

    fetchData();
  }, []);

  return (
    <Layout>
      <BasicHeader headingLine1="Sosyal Belediyecilik Anlayışına Sahip Mutlu Bir İlçe" headingLine2="" />
      <ListGrid items={tenderItems} showDateFilter={false} onFilterChange={() => {}} onItemClick={handleTenderClick} />
    </Layout>
  );
};

export default IhaleDuyurulari;
